import { createFeature, createReducer, on } from '@ngrx/store';

import { AiModelsActions } from './ai-models.actions';
import { AiModelDto } from './models/ai-model.model';

export interface AiModelsState {
  error: string | null;
  loading: boolean;
  aiModels: AiModelDto[];
}

export const initialState: AiModelsState = {
  error: null,
  loading: false,
  aiModels: [],
};

const reducer = createReducer(
  initialState,
  on(AiModelsActions.getAIModels, (state) => ({ ...state, loading: true })),
  on(AiModelsActions.loadSuccess, (state, { aiModels }) => ({
    ...state,
    aiModels: aiModels?.map((am) => ({ ...am })) ?? [],
    loading: false,
  })),
  on(AiModelsActions.loadFailure, (state, { error }) => ({
    ...state,
    error: String(error),
    loading: false,
  })),
);

export const aiModelsFeature = createFeature({
  name: 'aiModels',
  reducer,
});
